import { render, staticRenderFns } from "./TransactionDetailsView.vue?vue&type=template&id=5e20fdd6&"
import script from "./TransactionDetailsView.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailsView.vue?vue&type=style&index=0&id=5e20fdd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports